import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    item: {
        borderBottomWidth: 1,
        padding: 15
    },
    scrollView: {
        borderRadius: 10,
        borderWidth: 1,
        height: 300
    },
    descText: {
        marginBottom: 20
    }
});
export default stylesheet;
